import * as React from 'react';
import { Tooltip } from 'components';
import { IMeta } from 'models/common';
import renderIcon from 'helpers/renderIcon';
const classNames = require('classnames');

interface IProps {
	usage?: 'portal' | 'admin';
	input?: any;
	label?: any;
	type?: any;
	meta?: IMeta;
	autoFocus?: any;
	isDisabled?: boolean;
	onChangeAction?: any;
	tooltipText?: string;
	tooltipPosition?: any;
	description?: string;
	information?: string;
	inLabelAlready?: boolean;
	inverse?: boolean; // Visually switches true and false (checked if false, unchecked if  true)
	image?: string;
	jobTitle?: string;
	dontShowCustomer?: boolean;
}

const CustomerCheckboxFieldLabel = (props: {
	tag: 'label' | 'div';
	name: string;
	image?: string;
	text: any;
	jobTitle: string;
	dontShowCustomer?: boolean;
}) => {
	const Tag = props.tag || 'label';
	return (
		<Tag htmlFor={Tag === 'label' ? props.name : undefined} className="customerCheckboxField__inputLabel">
			{props.image ? (
				<img src={props.image.replace('img/', 'img/small')} />
			) : props.dontShowCustomer ? null : (
				renderIcon('pfp_default', 40, 40, 'customerCheckboxField__inputLabel__icon')
			)}
			<div className="customerCheckboxField__inputLabel__textContainer">
				<p className="customerCheckboxField__inputLabel__textContainer__name">{props.text}</p>
				<p className="customerCheckboxField__inputLabel__textContainer__jobTitle">{props.jobTitle}</p>
			</div>
		</Tag>
	);
};

export const CustomerCheckboxField = (props: IProps) => {
	let informationContainer: JSX.Element = null;
	if (typeof props.information !== 'undefined' && props.information !== null) {
		informationContainer = <div className="informationBlock">{props.information}</div>;
	}

	const usage = props.usage ? props.usage : 'portal';

	let description = props.description;
	let status = '';
	if (props.meta?.touched) {
		if (props.meta?.warning) {
			status = 'withWarning';
			description = props.meta.warning;
		}
		if (props.meta?.error) {
			description = props.meta.error;
			status = 'withError';
		}
	}

	const Tag = props.inLabelAlready ? 'div' : 'label';

	return (
		<div className={classNames('customerCheckboxField', usage, status)}>
			{informationContainer}
			<Tag
				className={'checkboxHolder pointer' + (props.inverse ? ' inverse' : '') + (props.isDisabled ? ' disabled' : '')}
			>
				<input
					{...props.input}
					className={props.meta?.touched && props.meta?.error ? 'inputError' : ''}
					id={props.input.name}
					type={props.type || props.input.type || 'checkbox'}
					autoFocus={props.autoFocus}
					disabled={props.isDisabled}
					onChange={(e) => {
						if (props.input.onChange) {
							props.input.onChange(e);
						}
						if (props.onChangeAction) {
							props.onChangeAction(e);
						}
					}}
				/>
				<CustomerCheckboxFieldLabel
					name={props.input.name}
					text={props.label}
					image={props.image}
					tag="div"
					jobTitle={props.jobTitle}
					dontShowCustomer={props.dontShowCustomer}
				/>
				{props.tooltipText && props.tooltipText.length > 0 ? (
					<Tooltip position={props.tooltipPosition} message={props.tooltipText}>
						<a href="#" onClick={(e) => e.preventDefault()}>
							<img src={require('containers/Html/icons/tooltip-icon.png')} />
						</a>
					</Tooltip>
				) : null}
			</Tag>
			{description ? <span className="note">{description}</span> : null}
		</div>
	);
};
